import { Dispatch, SetStateAction, useEffect, useMemo, useState } from "react"
import { InputModel } from "../../../../../../../../utils/types"
import { getArea, getDepartments, getDivisions, getRoles, getStore, getUserTypes } from "../../../../../../../../utils/methods/geServiceWithItemsFormat"
import { Roles } from "../../../../../../../../utils/enums"
import { Item } from "../../../../../../../../utils/types/generals"
import { useFilter } from "../../../../../../../../hooks/filter"
import { FilterProps } from "../../../../../../../../hooks/filter/typing"
import { removeAllReference } from "../../../../../../../../utils/methods/removedReference"
import { reportFolioServices } from "../../../../../../../../utils/constants/callService"
import { returnQuery } from "../../../../../../../../utils/methods/returnQuery"
import { Types } from '../../../../../../../../utils/enums'
import { useTranslation } from "react-i18next"
import { LoadData } from "../../components/users/types"
import { BodyUsers } from "../../types"
import { channelSending } from "../constans/constans"
import { ChannelSend } from "../enums/tabs"

const formatFilter = {
  from: "start_date",
  to: 'end_date',
  status: "status_ids",
  role: "role_ids",
  stores: "store_ids",
  userType: "user_type_ids",
  area: "areas_ids",
  department: "departments_ids"
}

const useInput = ({ setSelectedUsers, closeDrawer }: { setSelectedUsers: Dispatch<SetStateAction<string[]>>; closeDrawer: () => void }) => {

  const { t } = useTranslation()
  const [body, setBody] = useState<BodyUsers>({ users: [] })

  const [checks, setChecks] = useState<Record<ChannelSend, boolean>>({
    [ChannelSend.EMAIL]: false,
    [ChannelSend.APP]: false,
  });
  /* const extraQuery = `email=${checks[ChannelSend.EMAIL]}&app=${checks[ChannelSend.APP]}&` */

  const [inputCreate, setInputCreate] = useState({
    search: {
      label: 'general.searchUsers',
      translate: true,
      name: 'search',
      value: null,
    },
    from: {
      label: 'general.tags.from',
      translate: true,
      name: 'from',
      type: 'date',
      value: null,
      rest: {
        max: 'to',
      },
      size: {
        xl: 6,
        lg: 6,
        md: 6,
        sm: 6,
        xs: 6,
      },
    },
    to: {
      label: 'general.tags.to',
      translate: true,
      name: 'to',
      type: 'date',
      value: null,
      rest: {
        min: 'from',
      },
      size: {
        xl: 6,
        lg: 6,
        md: 6,
        sm: 6,
        xs: 6,
      },
    },
    role: {
      label: 'general.tags.role',
      translate: true,
      name: 'role',
      type: 'filter-select',
      items: [],
      value: null,
    },
    stores: {
      label: 'general.tags.store',
      translate: true,
      name: 'stores',
      type: 'filter-select',
      items: [],
      value: null,
    },
    division_ids: {
      label: 'general.tags.divisions',
      translate: true,
      name: 'division_ids',
      type: 'filter-select',
      items: [],
      value: null,
    },
    userType: {
      label: 'general.tags.userType',
      translate: true,
      name: 'userType',
      type: 'filter-select',
      items: [],
      value: null,
    },
    area: {
      label: 'general.tags.area',
      translate: true,
      name: 'area',
      type: 'filter-select',
      items: [],
      value: null,
    },
    department: {
      label: 'general.tags.department',
      translate: true,
      name: 'department',
      type: 'filter-select',
      items: [],
      value: null,
    },
  } as { [x: string]: InputModel })

  const [modalLoad, setModalLoad] = useState<{ open: boolean; tmpUsuers?: Record<string, string | boolean>[] }>({ open: false })
  const [snackbar, setSnackbar] = useState<{ open: boolean; type: Types; message: string }>({
    open: false,
    message: '',
    type: Types.SUCCESS,
  })
  const [loadings, setLoadings] = useState({ search: false, load: false, submit: false /* table: false, submit: false, main: false */ })
  const [allDepartments, setAllDepartments] = useState<Item[]>([])

  const searchUsers = async ({email, app}:{email:boolean, app:boolean}) => {
    try {
      const extraQuery = `email=${email}&app=${app}&`
      setLoadings(prev => ({ ...prev, search: true }))
      const response = await reportFolioServices.filterUsers({ query: `${extraQuery}status_ids=1&${returnQuery(createFilter.query, {})}` })
      let allUsers: Record<string, string | boolean>[] = response?.map(item => ({
        id: item.id.toString(),
        users: item.fullName,
        userType: item.userType ?? '',
        division: item.division,
        role: item.role ?? '',
        curp: item.curp ?? '',
        email: item.email == 1 ? true : false,
        app: item.app == 1 ? true : false
      })) ?? []
      if (!!allUsers?.length) {
        setModalLoad(prev => ({ ...prev, open: true, tmpUsuers: allUsers }))
      } else {
        setModalLoad(prev => ({ ...prev, open: true, tmpUsuers: [] }))
        setSnackbar(prev => ({ ...prev, open: true, message: t("general.messages.errors.noUsers"), type: Types.ERROR }))
      }
    } catch (e) {
      setModalLoad(prev => ({ ...prev, open: true, tmpUsuers: [] }))
      setSnackbar(prev => ({ ...prev, open: true, message: t("general.messages.errors.noUsers"), type: Types.ERROR }))
    }
    finally {
      setLoadings(prev => ({ ...prev, search: false }))
    }
  }

  const loadUsers: LoadData = async (listUsers: string[] | number[], email: boolean, app: boolean) => {

      setModalLoad((prev) => {
        const updatedTmpUsers = prev.tmpUsuers ? [...prev.tmpUsuers] : [];

        listUsers.forEach((user) => {
            const userId = String(user);
            const existingUserIndex = updatedTmpUsers.findIndex((u) => u.id === userId);

            if (existingUserIndex !== -1) {
                updatedTmpUsers[existingUserIndex] = {
                    ...updatedTmpUsers[existingUserIndex],
                    email: email,
                    app: app,
                };
            }
        });
        return { ...prev, tmpUsuers: updatedTmpUsers, open: true };
    });

    setBody((prevState) => {
      const updatedUsers = [...prevState.users];

      // Mapea sobre los usuarios que llegan en listUsers
      listUsers.forEach((user) => {
        const userId = Number(user);
        const existingUserIndex = updatedUsers.findIndex((u) => u.userId === userId);

        if (existingUserIndex !== -1) {
          // Si el usuario ya existe, actualizamos sus valores
          updatedUsers[existingUserIndex] = { userId, email, app };
        } else {
          // Si no existe, lo agregamos
          updatedUsers.push({ userId, email, app });
        }
      });

      return { users: updatedUsers };
    });

    closeDrawer()

  }

  const handleSubmitUser = async () => {
    setLoadings(prev => ({ ...prev, submit: true }))
    const response = await reportFolioServices.editConfigUsers({ body })

    if (!response.errors) {
      setSnackbar(prev => ({ ...prev, open: true, message: t("reportFolio.notificationCenter.snackBar.updateUsers.success"), type: Types.SUCCESS }))
      //cancelSearchUsers()
      setSelectedUsers([])
    } else {
      setSnackbar(prev => ({ ...prev, open: true, message: t("reportFolio.notificationCenter.snackBar.updateUsers.error"), type: Types.ERROR }))
    }

    setLoadings(prev => ({ ...prev, submit: false }))
    setBody({ users: [] })
  }

  const closeSnackbar = () => { setSnackbar(prev => ({ ...prev, open: false })) }

  const cancelSearchUsers = () => {
    createFilter.cleanFilter()
    setModalLoad(prev => ({ ...prev, open: false, tmpUsuers: [] }))
    setLoadings(prev => ({ ...prev, search: false }))
  }

  const externalValidation: FilterProps['externalValidation'] = ({ name, body, setFilterData }) => {
    let copyBody: Record<string, any> = removeAllReference(body)

    if (name === 'area') {
      const { area, department } = copyBody
      const newDepartments = department?.filter((e: any) => area.find((e2: any) => e2.value == e.areaId))
      let arrayChilds: any[] = []

      area?.forEach((e: any) => {
        const id = e.value
        const childs = allDepartments.filter((child) => child.areaId == id)
        arrayChilds.push(...childs)
      })

      setFilterData((prev) => ({
        ...prev,
        department: newDepartments,
      }))

      setInputCreate(prev => ({ ...prev, department: { ...prev.department, items: arrayChilds } }))
      copyBody = {
        ...copyBody,
        department: newDepartments,
      }
    }

    return copyBody
  }

  const getAllDepartments = async () => {
    const items = await getDepartments()
    setAllDepartments(items)

  }

  const getAllUnits = async () => {
    const { items } = await getStore()
    setInputCreate(prev => ({ ...prev, stores: { ...prev.stores, items } }))
  }

  const getAllUserTypes = async () => {
    const { items } = await getUserTypes()
    setInputCreate(prev => ({ ...prev, userType: { ...prev.userType, items } }))
  }

  const getAllRoles = async () => {
    const { items } = await getRoles({ skip: [Roles.ADMIN] })
    setInputCreate(prev => ({ ...prev, role: { ...prev.role, items } }))
  }

  const getAlDivisions = async () => {
    const { items } = await getDivisions()
    setInputCreate(prev => ({ ...prev, division_ids: { ...prev.division_ids, items } }))
  }

  const getAllAreas = async () => {
    const items = await getArea()
    setInputCreate(prev => ({ ...prev, area: { ...prev.area, items: items } }))
  }

  const getData = () => {
    getAllUnits()
    getAllUserTypes()
    getAllRoles()
    getAllAreas()
    getAllDepartments()
    getAlDivisions()
  }

  useEffect(() => {
    getData()
  }, [])

  const createFilter = useFilter({
    formatFilter,
    externalValidation,
  })

  return { inputCreate, createFilter, setChecks, checks, body, searchUsers, handleSubmitUser, modalLoad, snackbar, closeSnackbar, loadings, loadUsers, cancelSearchUsers, setSnackbar }
}


export { useInput }